var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{class:[_vm.$globalConfig.APP_NAME == 'senso' ? 'edify' : 'improve'],attrs:{"id":"improve"}},[_c('router-view'),_c('vue-snotify')],1)}
var staticRenderFns = []

export { render, staticRenderFns }